const FormAction = () => {
  let inputs = document.querySelectorAll(
    ".input-effect input, .input-effect select, .input-effect textarea"
  );

  inputs.forEach((el) => {
    if (el.value !== "") {
      el.closest(".input-effect").classList.add("has-content");
    } else el.closest(".input-effect").classList.remove("has-content");

    el.addEventListener("focusout", () => {
      if (el.value !== "") {
        el.closest(".input-effect").classList.add("has-content");
      } else el.closest(".input-effect").classList.remove("has-content");
    });

    el.addEventListener("focusin", () => {
      el.closest(".input-effect").classList.add("has-content");
    });

    el.addEventListener("blur", () => {
      el.closest(".input-effect").classList.add("has-content");
    });

    el.addEventListener("input", () => {
      el.closest(".input-effect").classList.add("has-content");
    });
  });

  let inputSearch = document.querySelectorAll(".form-group--search");

  inputSearch.forEach((el) => {
    let btnClear = el.querySelector(".btn-clear");
    btnClear.addEventListener("click", function handleClick(event) {
      event.preventDefault();
      const firstNameInput = el.querySelector(".input-search");
      firstNameInput.value = "";
    });
  });
};

export default FormAction;
